module.exports = __webpack_public_path__ + "eb65eb3114602af02ea74df3945b6b51.svg";